export default function parseJsonObject(value: string | null | undefined): Record<string, unknown> {
  if (!value) {
    return {};
  }

  if (value.trim().length === 0) {
    return {};
  }
  const v: unknown = JSON.parse(value);
  if (v === undefined || v === null) {
    throw Error();
  }
  if (typeof v !== 'object') {
    throw Error();
  }
  return v as Record<string, unknown>;
}
